import { type Component, createResource, Show } from 'solid-js'
import { useParams } from '@solidjs/router'
import { useAdminEvents } from '../../../shared/providers/coris/coris-admin-events.provider'
import { useUser } from '../../../shared/providers/user-provider'
import EventForm from './EventForm'
import { mapEventToFormData } from '../domain/map-event-to-form-data'

const AdminEventsEditPage: Component = () => {
  const params = useParams<{ eventId: string }>()
  const { getEventById } = useAdminEvents()
  const { organizationSlug } = useUser()

  const [event] = createResource(
    () => {
      const slug = organizationSlug()
      const id = params.eventId
      if (!slug || !id) return null
      return { slug, id }
    },
    async ({ id }) => getEventById(Number(id))
  )

  return (
    <Show
      when={!event.loading && event()}
      fallback={
        <div class="flex w-full items-center justify-center min-h-full">
          <div class="flex flex-col items-center gap-3">
            <div class="w-8 h-8 border-2 border-gray-300 border-t-primary-600 rounded-full animate-spin" />
            <span class="text-sm text-gray-500">Loading event...</span>
          </div>
        </div>
      }
    >
      <EventForm mode="edit" eventId={Number(params.eventId)} initialValues={mapEventToFormData(event()!)} />
    </Show>
  )
}

export default AdminEventsEditPage
